import React from "react";
import PropTypes from "prop-types";
import { Dialog } from "primereact/dialog";
import { PrimaryButton, SecondaryButton } from "../../../../components/Buttons";

const ConfirmationDialog = React.forwardRef(function ConfirmationDialog(props, ref) {
  const [state, setState] = React.useState({
    title: props.title,
    text: props.text,
    onConfirm: props.onConfirm,
    isVisible: false
  });

  const show = (isVisible, data, onConfirm) => {
    const newState = data || {};
    setState(prev => ({
      ...prev,
      ...newState,
      onConfirm,
      isVisible
    }));
  };

  const onHide = () => {
    setState(prev => ({ ...prev, isVisible: false }));
  };

  const onClick = (isYes) => {
    onHide();
    if (isYes && state.onConfirm) {
      state.onConfirm();
    }
  };

  React.useImperativeHandle(ref, () => ({ show }));

  const { title, text, isVisible } = state;
  const footer = (
    <div className="alg-right">
      <PrimaryButton className="margin-lft" onClick={() => onClick(true)}>Ja</PrimaryButton>
      <SecondaryButton className="margin-lft" onClick={() => onClick(false)}>Nein</SecondaryButton>
    </div>
  );
  return (
    <Dialog
      header={title}
      footer={footer}
      iconsTemplate={null}
      visible={isVisible}
      style={{width: "400px"}}
      modal={true}
      onHide={onHide}>
      <p>{text}</p>
    </Dialog>
  );
});

ConfirmationDialog.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  onConfirm: PropTypes.func
};

export default ConfirmationDialog;
